export const permissionKeys = {
  perm_010000: 'PolicyAdministration',
  perm_010001: 'PolicyAdministration,Module',
  perm_011000: 'PolicyAdministration,ManagePolicies',
  perm_011001: 'PolicyAdministration,ManagePolicies,Screen',
  perm_011005: 'PolicyAdministration,ManagePolicies,Policy',
  perm_011010: 'PolicyAdministration,ManagePolicies,Endorsement',
  perm_011015: 'PolicyAdministration,ManagePolicies,Renewal',
  perm_011020: 'PolicyAdministration,ManagePolicies,CopyPolicy',
  perm_011025: 'PolicyAdministration,ManagePolicies,AmendPolicy',
  perm_011030: 'PolicyAdministration,ManagePolicies,DeletePolicy',
  perm_011035: 'PolicyAdministration,ManagePolicies,PolicyDetailsList',
  perm_011040: 'PolicyAdministration,ManagePolicies,PolicyDetailsList,Section',
  perm_011045: 'PolicyAdministration,ManagePolicies,PolicyDetailsList,CreatePolicy',
  perm_011050: 'PolicyAdministration,ManagePolicies,PolicyDetailsList,AddColumns',
  perm_011055: 'PolicyAdministration,ManagePolicies,PolicyDetailsList,Edit',
  perm_011060: 'PolicyAdministration,ManagePolicies,PolicyDetailsList,Query',
  perm_011065: 'PolicyAdministration,ManagePolicies,RiskDetailsList',
  perm_011070: 'PolicyAdministration,ManagePolicies,RiskDetailsList,Section',
  perm_011075: 'PolicyAdministration,ManagePolicies,RiskDetailsList,AddColumns',
  perm_011080: 'PolicyAdministration,ManagePolicies,PolicySummary-Query',
  perm_011085: 'PolicyAdministration,ManagePolicies,PolicySummary-Query,Section',
  perm_011090: 'PolicyAdministration,ManagePolicies,PolicySummary-Query,PolicyTotal',
  perm_011095: 'PolicyAdministration,ManagePolicies,PolicyDetailsList,ExportPolicyList',
  perm_012000: 'PolicyAdministration,ProcessReinsurance',
  perm_012001: 'PolicyAdministration,ProcessReinsurance,Screen',
  perm_012005: 'PolicyAdministration,ProcessReinsurance,Reinsurance',
  perm_012010: 'PolicyAdministration,ProcessReinsurance,Endorsement',
  perm_012015: 'PolicyAdministration,ProcessReinsurance,AmendRI',
  perm_012020: 'PolicyAdministration,ProcessReinsurance,ReinsuranceList',
  perm_012025: 'PolicyAdministration,ProcessReinsurance,ReinsuranceList,Section',
  perm_012030: 'PolicyAdministration,ProcessReinsurance,ReinsuranceList,AddColumns',
  perm_012035: 'PolicyAdministration,ProcessReinsurance,ReinsuranceList,Edit',
  perm_012040: 'PolicyAdministration,ProcessReinsurance,ReinsuranceList,Query',
  perm_013000: 'PolicyAdministration,SpecialFunctions',
  perm_013001: 'PolicyAdministration,SpecialFunctions,Screen',
  perm_013005: 'PolicyAdministration,SpecialFunctions,BatchPolicyRelease',
  perm_013010: 'PolicyAdministration,SpecialFunctions,BatchRIOutwardsRelease',
  perm_013020: 'PolicyAdministration,SpecialFunctions,DeleteUnrealeasedRenewals',
  perm_013025: 'PolicyAdministration,SpecialFunctions,NCDDetails(Merimen)',
  perm_013030: 'PolicyAdministration,SpecialFunctions,ProcessRenewals',
  perm_013035: 'PolicyAdministration,SpecialFunctions,RiskAccumulation',
  perm_013040: 'PolicyAdministration,SpecialFunctions,RiskSurvey',
  perm_013045: 'PolicyAdministration,SpecialFunctions,TreatyCesssionNormalisation',
  perm_013015: 'PolicyAdministration,SpecialFunctions,BlockNormalisation',
  perm_013050: 'PolicyAdministration,SpecialFunctions,UndoPolicyRelease',
  perm_013055: 'PolicyAdministration,SpecialFunctions,UOBProposalDownload',
  perm_013060: 'PolicyAdministration,SpecialFunctions,UOBProposalUpload',
  perm_013065: 'PolicyAdministration,SpecialFunctions,RiskAccumulationQuery',
  perm_014000: 'PolicyAdministration,Interface',
  perm_014001: 'PolicyAdministration,Interface,Screen',
  perm_014005: 'PolicyAdministration,Interface,GIAMotorTransactions',
  perm_014010: 'PolicyAdministration,Interface,GIATravelClaims',
  perm_014015: 'PolicyAdministration,Interface,GIAWICTransactions',
  perm_014020: 'PolicyAdministration,Interface,LTAMotorPolicies',
  perm_014025: 'PolicyAdministration,Interface,LTAPurgeVehicleDetailsRequest',
  perm_014030: 'PolicyAdministration,Interface,LTAQueryVehicleDetailsRequest',
  perm_014035: 'PolicyAdministration,Interface,LTAQueryVehicleRegistration&ChassisChange',
  perm_014045: 'PolicyAdministration,Interface,LTAUploadVehicleDetailsRequest(C,F)',
  perm_014050: 'PolicyAdministration,Interface,LTAUploadVehicleRegistration&ChassisChangeFile',
  perm_014040: 'PolicyAdministration,Interface,LTAUnsetTransmissionDate',
  perm_014055: 'PolicyAdministration,Interface,MASAMLReport',
  perm_014060: 'PolicyAdministration,Interface,MASSanctionList',
  perm_014065: 'PolicyAdministration,Interface,MASUploadSanctionList',
  perm_014070: 'PolicyAdministration,Interface,MOMBondPolicies',
  perm_014075: 'PolicyAdministration,Interface,MOMUnsetBondPoliciesDateforRe-submission',
  perm_014080: 'PolicyAdministration,Interface,MOMWICPolicies',
  perm_014085: 'PolicyAdministration,Interface,SendToLTA',
  perm_014090: 'PolicyAdministration,Interface,LTADataFile3',
  perm_014095: 'PolicyAdministration,Interface,ManageLTAADEX',
  perm_014100: 'PolicyAdministration,Interface,UploadPostalCode',
  perm_014105: 'PolicyAdministration,Interface,MOMAuditWICPolicies',
  perm_015000: 'PolicyAdministration,Documents',
  perm_015001: 'PolicyAdministration,Documents,Screen',
  perm_015005: 'PolicyAdministration,Documents,PolicyDocumentation',
  perm_015010: 'PolicyAdministration,Documents,PolicyScheduleFire',
  perm_015015: 'PolicyAdministration,Documents,PolicyScheduleMarine',
  perm_015020: 'PolicyAdministration,Documents,PolicyScheduleMiscellaneous',
  perm_015025: 'PolicyAdministration,Documents,PolicyScheduleMotor',
  perm_015030: 'PolicyAdministration,Documents,LossofCIDeclaration',
  perm_016000: 'PolicyAdministration,UOBProposals,',
  perm_016001: 'PolicyAdministration,UOBProposals,Screen',
  perm_016005: 'PolicyAdministration,UOBProposals,Proposal',
  perm_016010: 'PolicyAdministration,UOBProposals,Proposal,Section',
  perm_016015: 'PolicyAdministration,UOBProposals,Proposal,Edit',
  perm_016020: 'PolicyAdministration,UOBProposals,Proposal,Query',
  perm_016025: 'PolicyAdministration,UOBProposals,Conversion',
  perm_016030: 'PolicyAdministration,UOBProposals,Conversion,Section',
  perm_016035: 'PolicyAdministration,UOBProposals,Conversion,Convert',
  perm_016040: 'PolicyAdministration,UOBProposals,Conversion,Query',
  perm_040000: 'Accounting',
  perm_040001: 'Accounting,Module',
  perm_041000: 'Accounting,ManageAccounts',
  perm_041001: 'Accounting,ManageAccounts,Screen',
  perm_041005: 'Accounting,ManageAccounts,Accounts',
  perm_041010: 'Accounting,ManageAccounts,Receipt',
  perm_041015: 'Accounting,ManageAccounts,Receipt,Section',
  perm_041020: 'Accounting,ManageAccounts,Receipt,Delete',
  perm_041025: 'Accounting,ManageAccounts,Receipt,Edit',
  perm_041030: 'Accounting,ManageAccounts,Receipt,Query',
  perm_041035: 'Accounting,ManageAccounts,Receipt,EnterMultipleAccountsforReceipts',
  perm_041040: 'Accounting,ManageAccounts,Receipt,NewReceipts',
  perm_041045: 'Accounting,ManageAccounts,Payment',
  perm_041050: 'Accounting,ManageAccounts,Payment,Section',
  perm_041055: 'Accounting,ManageAccounts,Payment,Delete',
  perm_041060: 'Accounting,ManageAccounts,Payment,Edit',
  perm_041065: 'Accounting,ManageAccounts,Payment,Query',
  perm_041070: 'Accounting,ManageAccounts,Payment,EnterMultipleAccountsforPayment',
  perm_041075: 'Accounting,ManageAccounts,Payment,NewPayment',
  perm_041080: 'Accounting,ManageAccounts,CreditNote',
  perm_041085: 'Accounting,ManageAccounts,CreditNote,Section',
  perm_041090: 'Accounting,ManageAccounts,CreditNote,Delete',
  perm_041095: 'Accounting,ManageAccounts,CreditNote,Edit',
  perm_041100: 'Accounting,ManageAccounts,CreditNote,Query',
  perm_041105: 'Accounting,ManageAccounts,CreditNote,NewCreditNote',
  perm_041110: 'Accounting,ManageAccounts,DebitNote',
  perm_041115: 'Accounting,ManageAccounts,DebitNote,Section',
  perm_041120: 'Accounting,ManageAccounts,DebitNote,Delete',
  perm_041125: 'Accounting,ManageAccounts,DebitNote,Edit',
  perm_041130: 'Accounting,ManageAccounts,DebitNote,Query',
  perm_041135: 'Accounting,ManageAccounts,DebitNote,NewDebitNote',
  perm_041140: 'Accounting,ManageAccounts,AccountsList',
  perm_041145: 'Accounting,ManageAccounts,AccountsList,Section',
  perm_041150: 'Accounting,ManageAccounts,AccountsList,Delete',
  perm_041155: 'Accounting,ManageAccounts,AccountsList,Edit',
  perm_041160: 'Accounting,ManageAccounts,AccountsList,Query',
  perm_041165: 'Accounting,ManageAccounts,GLTransList',
  perm_041170: 'Accounting,ManageAccounts,GLTransList,Section',
  perm_041175: 'Accounting,ManageAccounts,GLTransList,Query',
  perm_041180: 'Accounting,ManageAccounts,MatchedList',
  perm_041185: 'Accounting,ManageAccounts,MatchedList,Section',
  perm_041190: 'Accounting,ManageAccounts,MatchedList,Query',
  perm_041195: 'Accounting,ManageAccounts,CommissionList',
  perm_041200: 'Accounting,ManageAccounts,CommissionList,Section',
  perm_041205: 'Accounting,ManageAccounts,CommissionList,Query',
  perm_041210: 'Accounting,ManageAccounts,NonTrade',
  perm_041215: 'Accounting,ManageAccounts,NonTrade,Section',
  perm_041220: 'Accounting,ManageAccounts,NonTrade,Delete',
  perm_041225: 'Accounting,ManageAccounts,NonTrade,Edit',
  perm_041230: 'Accounting,ManageAccounts,NonTrade,Query',
  perm_041235: 'Accounting,ManageAccounts,AccountsList,ExportAcctList',
  perm_041240: 'Accounting,ManageAccounts,Receipt,ExportAcctList',
  perm_041245: 'Accounting,ManageAccounts,Payment,ExportAcctList',
  perm_041250: 'Accounting,ManageAccounts,CreditNote,ExportAcctList',
  perm_041255: 'Accounting,ManageAccounts,DebitNote,ExportAcctList',
  perm_041260: 'Accounting,ManageAccounts,NonTrade,ExportAcctList',
  perm_030000: 'ClaimsManagement',
  perm_030001: 'ClaimsManagement,Module',
  perm_031000: 'ClaimsManagement,ManageClaims',
  perm_031001: 'ClaimsManagement,ManageClaims,Screen',
  perm_031005: 'ClaimsManagement,ManageClaims,Claim',
  perm_031010: 'ClaimsManagement,ManageClaims,Payment',
  perm_031015: 'ClaimsManagement,ManageClaims,ReopenClaim',
  perm_031020: 'ClaimsManagement,ManageClaims,DeleteClaim',
  perm_031025: 'ClaimsManagement,ManageClaims,ClaimList',
  perm_031030: 'ClaimsManagement,ManageClaims,ClaimList,Section',
  perm_031035: 'ClaimsManagement,ManageClaims,ClaimList,CreateClaim',
  perm_031040: 'ClaimsManagement,ManageClaims,ClaimList,AddColumns',
  perm_031045: 'ClaimsManagement,ManageClaims,ClaimList,Edit',
  perm_031050: 'ClaimsManagement,ManageClaims,ClaimList,Query',
  perm_031055: 'ClaimsManagement,ManageClaims,ClaimEntry',
  perm_031060: 'ClaimsManagement,ManageClaims,ClaimEntry,Section',
  perm_031065: 'ClaimsManagement,ManageClaims,ClaimEntry,ViewAttachments',
  perm_031070: 'ClaimsManagement,ManageClaims,ClaimEntry,DeleteAttachments',
  perm_031075: 'ClaimsManagement,ManageClaims,ClaimEntry,ViewReserves',
  perm_031080: 'ClaimsManagement,ManageClaims,ClaimEntry,ViewPayment',
  perm_031085: 'ClaimsManagement,ManageClaims,ClaimEntry,DownloadAttachments',
  perm_031090: 'ClaimsManagement,ManageClaims,ClaimEntry,ClaimHandler',
  perm_031095: 'ClaimsManagement,ManageClaims,ClaimList,ExportClaimList',
  perm_031500: 'ClaimsManagement,RenewalMessage',
  perm_031550: 'ClaimsManagement,RenewalMessage,Screen',
  perm_031600: 'ClaimsManagement,RenewalMessage,RenewalMessageList',
  perm_031605: 'ClaimsManagement,RenewalMessage,RenewalMessageList,Section',
  perm_031610: 'ClaimsManagement,RenewalMessage,RenewalMessageList,Delete',
  perm_031615: 'ClaimsManagement,RenewalMessage,RenewalMessageList,Edit',
  perm_031620: 'ClaimsManagement,RenewalMessage,RenewalMessageList,Query',
  perm_031625: 'ClaimsManagement,RenewalMessage,RenewalMessageList,CreateRenewalMessage',
  perm_032000: 'ClaimsManagement,SpecialFunctions',
  perm_032001: 'ClaimsManagement,SpecialFunctions,Screen',
  perm_032005: 'ClaimsManagement,SpecialFunctions,ClaimsReserveRevaluation',
  perm_032010: 'ClaimsManagement,SpecialFunctions,DeleteUnreleasedClaimsTransaction',
  perm_032015: 'ClaimsManagement,SpecialFunctions,GenerateXOLRecoveries',
  perm_009604: 'ClaimsManagement,SpecialFunctions,PostIBNRClaimsReserve',
  perm_032020: 'ClaimsManagement,SpecialFunctions,PostOutstandingClaimsReserve',
  perm_032025: 'ClaimsManagement,SpecialFunctions,ProcessClaimsRIRecoveries',
  perm_032030: 'ClaimsManagement,SpecialFunctions,ReleaseClaimsTransaction',
  perm_032035: 'ClaimsManagement,SpecialFunctions,UnsetClaimsDocumentsPrintFlag',
  perm_032040: 'ClaimsManagement,SpecialFunctions,XOLWorksheet',
  perm_033000: 'ClaimsManagement,Documents',
  perm_033001: 'ClaimsManagement,Documents,Screen',
  perm_033005: 'ClaimsManagement,Documents,ClaimsCreditNote',
  perm_033010: 'ClaimsManagement,Documents,ClaimsDebitNote',
  perm_033015: 'ClaimsManagement,Documents,ClaimsPaymentVoucher',
  perm_033020: 'ClaimsManagement,Documents,ClaimsReceipt',
  perm_033025: 'ClaimsManagement,Documents,ClaimsFaceSheet',
  perm_033030: 'ClaimsManagement,Documents,ClaimsRIAdvice',
  perm_050000: 'ClientManagement',
  perm_050001: 'ClientManagement,Module',
  perm_050100: 'ClientManagement,ManageInsured',
  perm_050101: 'ClientManagement,ManageInsured,Screen',
  perm_050105: 'ClientManagement,ManageInsured,Insured',
  perm_050110: 'ClientManagement,ManageInsured,Insured,Section',
  perm_050115: 'ClientManagement,ManageInsured,Insured,NewInsured',
  perm_050120: 'ClientManagement,ManageInsured,Insured,Delete',
  perm_050125: 'ClientManagement,ManageInsured,Insured,Edit',
  perm_050130: 'ClientManagement,ManageInsured,Insured,Query',
  perm_050200: 'ClientManagement,ManageIntermediary',
  perm_050201: 'ClientManagement,ManageIntermediary,Screen',
  perm_050205: 'ClientManagement,ManageIntermediary,Intermediary',
  perm_050210: 'ClientManagement,ManageIntermediary,PermittedSchemeperIntermediary',
  perm_050300: 'ClientManagement,CustomerLogHistory',
  perm_050301: 'ClientManagement,CustomerLogHistory,Screen',
  perm_050400: 'ClientManagement,CustomerLogStatistics',
  perm_050401: 'ClientManagement,CustomerLogStatistics,Screen',
  perm_051000: 'Reports',
  perm_051001: 'Reports,Module',
  perm_051500: 'Reports,UnderwritingReports',
  perm_051501: 'Reports,UnderwritingReports,Screen',
  perm_051505: 'Reports,UnderwritingReports,AutoBatchRenewal',
  perm_051510: 'Reports,UnderwritingReports,AutoRenewalCoveringLetter',
  perm_051520: 'Reports,UnderwritingReports,CoinsurancePremiums',
  perm_011700: 'Reports,UnderwritingReports,Collaterals',
  perm_051525: 'Reports,UnderwritingReports,ConsolidatedPremiums',
  perm_051545: 'Reports,UnderwritingReports,InwardsBusinessAnalysis-Gross',
  perm_051550: 'Reports,UnderwritingReports,InwardsPremiumRegister',
  perm_051565: 'Reports,UnderwritingReports,PolicyChecklist',
  perm_051570: 'Reports,UnderwritingReports,Premium&ClaimsSummary',
  perm_051575: 'Reports,UnderwritingReports,PremiumAnalysis1',
  perm_051580: 'Reports,UnderwritingReports,PremiumAnalysis2',
  perm_012300: 'Reports,UnderwritingReports,PremiumComparison',
  perm_051590: 'Reports,UnderwritingReports,PremiumSummary',
  perm_051595: 'Reports,UnderwritingReports,ProductivityStatistics',
  perm_051615: 'Reports,UnderwritingReports,Renewals',
  perm_012700: 'Reports,UnderwritingReports,RiskAccumulation',
  perm_051625: 'Reports,UnderwritingReports,RiskProfiles',
  perm_051555: 'Reports,UnderwritingReports,TransactionByAcctNo',
  perm_013100: 'Reports,UnderwritingReports,UnearnedPremiumReserves',
  perm_051515: 'Reports,UnderwritingReports,BlockParametersChecklist',
  perm_051530: 'Reports,UnderwritingReports,ExpiringPoliciesRIPanel',
  perm_051535: 'Reports,UnderwritingReports,ExpiringPolicieswithFinancialInstitution',
  perm_051540: 'Reports,UnderwritingReports,FireFreeInsuranceExpiring',
  perm_051585: 'Reports,UnderwritingReports,PremiumIncomeforPropertiesMortgaged',
  perm_051600: 'Reports,UnderwritingReports,ProfitabilityStatistics',
  perm_051605: 'Reports,UnderwritingReports,Redemptions',
  perm_051610: 'Reports,UnderwritingReports,RenewalPoliciesNotReleased',
  perm_051620: 'Reports,UnderwritingReports,RiskBlockSIChecklist',
  perm_051630: 'Reports,UnderwritingReports,RiskSurveys',
  perm_051635: 'Reports,UnderwritingReports,SDSReceipt,PaymentTransactions',
  perm_051560: 'Reports,UnderwritingReports,MonthlySurplusTreaty',
  perm_051640: 'Reports,UnderwritingReports,StatisticsbyBusinessGroup',
  perm_051645: 'Reports,UnderwritingReports,TreatyLimitChecklist',
  perm_051650: 'Reports,UnderwritingReports,TypeofBusinessAnalysis',
  perm_051655: 'Reports,UnderwritingReports,UOBProposalChecklist',
  perm_051660: 'Reports,UnderwritingReports,AutoBatchRenewalUPP',
  perm_051665: 'Reports,UnderwritingReports,AutoBatchRenewalUPPListing',
  perm_051670: 'Reports,UnderwritingReports,PrintLTARequest/Response',
  perm_051675: 'Reports,UnderwritingReports,PoliciesDueToExpire',
  perm_051680: 'Reports,UnderwritingReports,RenewalListing',
  perm_051685: 'Reports,UnderwritingReports,BonusIncentiveScheme',
  perm_051690: 'Reports,UnderwritingReports,ProfitabilitybyA/CYear',
  perm_051695: 'Reports,UnderwritingReports,LadderStatistics',
  perm_051700: 'Reports,UnderwritingReports,SurplusTreatyMasterlist',
  perm_051705: 'Reports,UnderwritingReports,AutoBatchRenewalHDB',
  perm_052000: 'Reports,ReinsuranceReports',
  perm_013300: 'Reports,ReinsuranceReports,Screen',
  perm_052010: 'Reports,ReinsuranceReports,FacultativeRIBordereaux',
  perm_052015: 'Reports,ReinsuranceReports,GNPI&XOLPremiums',
  perm_052020: 'Reports,ReinsuranceReports,OpenCoverFacRIBordereaux',
  perm_052025: 'Reports,ReinsuranceReports,OutwardsPremiums&Commissions',
  perm_052030: 'Reports,ReinsuranceReports,OutwardsPremiumRegister',
  perm_052045: 'Reports,ReinsuranceReports,RIOutwardsChecklist',
  perm_052005: 'Reports,ReinsuranceReports,ContractCertainty',
  perm_052035: 'Reports,ReinsuranceReports,RIApplicationBordereaux',
  perm_052040: 'Reports,ReinsuranceReports,RIGrossPremiumStatistics',
  perm_052050: 'Reports,ReinsuranceReports,SurplusTreatyMasterlist',
  perm_052055: 'Reports,ReinsuranceReports,SurplusTreatyTransactions',
  perm_052060: 'Reports,ReinsuranceReports,TreatyOutwardsTransChecklist',
  perm_052065: 'Reports,ReinsuranceReports,PoliciesPendingReinsurance',
  perm_052070: 'Reports,ReinsuranceReports,PremiumAnalysis2',
  perm_052500: 'Reports,ClaimsReports',
  perm_052501: 'Reports,ClaimsReports,Screen',
  perm_052505: 'Reports,ClaimsReports,ClaimsGrossReserves',
  perm_052510: 'Reports,ClaimsReports,ClaimsPaid&LossReserves',
  perm_052515: 'Reports,ClaimsReports,ClaimsPayments',
  perm_052520: 'Reports,ClaimsReports,ClaimsRegister',
  perm_052525: 'Reports,ClaimsReports,ClaimsRIAdjustmentChecklist',
  perm_052530: 'Reports,ClaimsReports,ClaimsRIBordereaux',
  perm_052535: 'Reports,ClaimsReports,LadderStatistics',
  perm_052540: 'Reports,ClaimsReports,NewClaimsChecklistw/oReserves',
  perm_052545: 'Reports,ClaimsReports,RIClaimsSummary',
  perm_052550: 'Reports,ClaimsReports,RIOutwardsClaimsSummary',
  perm_052555: 'Reports,ClaimsReports,ClaimsMovement',
  perm_052560: 'Reports,ClaimsReports,ClaimByNext/LastReviewDate',
  perm_052565: 'Reports,ClaimsReports,ClaimsListingbyAgent/Account',
  perm_052570: 'Reports,ClaimsReports,O/SClaimsRIBordereaux',
  perm_052575: 'Reports,ClaimsReports,UserApprovalList',
  perm_052580: 'Reports,ClaimsReports,ClaimsGrossReservesUW',
  perm_014400: 'Reports,ClaimsReports,ClaimsTPRecoveries',
  perm_014600: 'Reports,ClaimsReports,OutstandingClaimsRIBordereaux',
  perm_014700: 'Reports,ClaimsReports,PremiumandClaimsStatistics',
  perm_053000: 'Reports,AccountsReports',
  perm_053001: 'Reports,AccountsReports,Screen',
  perm_053005: 'Reports,AccountsReports,AccountsTransactions',
  perm_015300: 'Reports,AccountsReports,AdjustmentDebit,CreditNotes',
  perm_053010: 'Reports,AccountsReports,AgedDebtorsAnalysis',
  perm_053015: 'Reports,AccountsReports,BankAccounts',
  perm_015600: 'Reports,AccountsReports,CreditControl',
  perm_053020: 'Reports,AccountsReports,FinancialStatements',
  perm_053025: 'Reports,AccountsReports,GLReports',
  perm_053030: 'Reports,AccountsReports,Gross&RICededStatistics',
  perm_053035: 'Reports,AccountsReports,GSTReports',
  perm_053040: 'Reports,AccountsReports,MatchedAccountsTransactions',
  perm_053045: 'Reports,AccountsReports,UnearnedPremiumReserves',
  perm_053050: 'Reports,AccountsReports,UnmatchedAccountsTransactions',
  perm_053055: 'Reports,AccountsReports,VoluntaryCessions',
  perm_053060: 'Reports,AccountsReports,ClaimsInput&OutputTax',
  perm_053065: 'Reports,AccountsReports,GLPostingChecklist',
  perm_053070: 'Reports,AccountsReports,CSPremiumAnalysis2',
  perm_016300: 'Reports,SpecialReports,RBCReports',
  perm_053500: 'Reports,TreatyReports',
  perm_053501: 'Reports,TreatyReports,Screen',
  perm_053505: 'Reports,TreatyReports,OutwardsTreatyPremium&Commission',
  perm_053510: 'Reports,TreatyReports,TreatyAccountingClosing',
  perm_053515: 'Reports,TreatyReports,TreatyOutstandingClaims',
  perm_053520: 'Reports,TreatyReports,TreatyRIAging',
  perm_053525: 'Reports,TreatyReports,TreatyStatementAuditListB',
  perm_054000: 'Reports,CustomReports1',
  perm_054001: 'Reports,CustomReports1,Screen',
  perm_054005: 'Reports,CustomReports1,ClaimsRIRecovery',
  perm_054010: 'Reports,CustomReports1,CodeofPractice',
  perm_054015: 'Reports,CustomReports1,CoinsuranceFeeDetails',
  perm_054020: 'Reports,CustomReports1,CrossSelling',
  perm_054025: 'Reports,CustomReports1,GLList',
  perm_054030: 'Reports,CustomReports1,GLStat',
  perm_054035: 'Reports,CustomReports1,New&RenewalPolicy',
  perm_054040: 'Reports,CustomReports1,RenewalPolicyStatus',
  perm_054045: 'Reports,CustomReports1,RIBusinessStatistics',
  perm_054050: 'Reports,CustomReports1,SOASupplement',
  perm_054055: 'Reports,CustomReports1,TakafulStatistics',
  perm_054060: 'Reports,CustomReports1,UOBInstructionSlip',
  perm_054065: 'Reports,CustomReports1,UPRList',
  perm_054070: 'Reports,CustomReports1,DirectorRelationship',
  perm_054075: 'Reports,CustomReports1,PolReviewRelUsr',
  perm_054080: 'Reports,CustomReports1,ClaimWithLate',
  perm_054085: 'Reports,CustomReports1,MASInsExp',
  perm_054090: 'Reports,CustomReports1,SurplusTreatyMasterlistFormat',
  perm_054500: 'Reports,CustomReports2',
  perm_054501: 'Reports,CustomReports2,Screen',
  perm_055000: 'Parameters',
  perm_055001: 'Parameters,Module',
  perm_055500: 'Parameters,Wizards',
  perm_055501: 'Parameters,Wizards,Screen',
  perm_056000: 'Parameters,GlobalParameters',
  perm_056001: 'Parameters,GlobalParameters,Screen',
  perm_056005: 'Parameters,GlobalParameters,BusinessClass',
  perm_056010: 'Parameters,GlobalParameters,Clause',
  perm_056015: 'Parameters,GlobalParameters,Company',
  perm_056020: 'Parameters,GlobalParameters,Country',
  perm_056025: 'Parameters,GlobalParameters,CoverageType',
  perm_056030: 'Parameters,GlobalParameters,Currency',
  perm_056035: 'Parameters,GlobalParameters,DefaultText',
  perm_056040: 'Parameters,GlobalParameters,DocumentHeading',
  perm_056045: 'Parameters,GlobalParameters,DocumentNo.Format',
  perm_056050: 'Parameters,GlobalParameters,MiscellaneousParameters',
  perm_056055: 'Parameters,GlobalParameters,PaymentMethod',
  perm_056060: 'Parameters,GlobalParameters,PolicyType',
  perm_017700: 'Parameters,GlobalParameters,RBC',
  perm_056065: 'Parameters,GlobalParameters,ProcessNotificationSettings',
  perm_056070: 'Parameters,GlobalParameters,StandardRiskText',
  perm_056075: 'Parameters,GlobalParameters,StatisticType',
  perm_056080: 'Parameters,GlobalParameters,VariousSequenceNo.',
  perm_017900: 'Parameters,UnderwritingParameters',
  perm_018000: 'Parameters,UnderwritingParameters,Screen',
  perm_056505: 'Parameters,UnderwritingParameters,Benefit',
  perm_056510: 'Parameters,UnderwritingParameters,BonusIncentiveScheme',
  perm_056515: 'Parameters,UnderwritingParameters,BusinessSource',
  perm_056520: 'Parameters,UnderwritingParameters,Campaign',
  perm_056525: 'Parameters,UnderwritingParameters,CoverLetter',
  perm_056530: 'Parameters,UnderwritingParameters,CustomerLogType',
  perm_056535: 'Parameters,UnderwritingParameters,Discount,LoadingType',
  perm_056540: 'Parameters,UnderwritingParameters,EndorsementCode',
  perm_056545: 'Parameters,UnderwritingParameters,FireDistrictClass',
  perm_056550: 'Parameters,UnderwritingParameters,IndustryGroup',
  perm_056555: 'Parameters,UnderwritingParameters,MarineCargoCommodity',
  perm_056560: 'Parameters,UnderwritingParameters,MarineVesselMaster',
  perm_056565: 'Parameters,UnderwritingParameters,MotorVehicleGroup',
  perm_018600: 'Parameters,UnderwritingParameters,PAandHealth',
  perm_018700: 'Parameters,UnderwritingParameters,Package',
  perm_056570: 'Parameters,UnderwritingParameters,PolicyStatus',
  perm_056575: 'Parameters,UnderwritingParameters,RiskProfile',
  perm_056580: 'Parameters,UnderwritingParameters,Scheme',
  perm_056585: 'Parameters,UnderwritingParameters,ShortTermRate',
  perm_056590: 'Parameters,UnderwritingParameters,Tariff',
  perm_056595: 'Parameters,UnderwritingParameters,UnitofMeasure',
  perm_056600: 'Parameters,UnderwritingParameters,UOBProposalPlan',
  perm_056605: 'Parameters,UnderwritingParameters,UOBProposalStatus',
  perm_056610: 'Parameters,UnderwritingParameters,PermittedBenefitPerBusinessClass',
  perm_057000: 'Parameters,ReinsuranceParameters',
  perm_057001: 'Parameters,ReinsuranceParameters,Screen',
  perm_057005: 'Parameters,ReinsuranceParameters,AccumulationType',
  perm_057010: 'Parameters,ReinsuranceParameters,BlockGroup',
  perm_057015: 'Parameters,ReinsuranceParameters,CO,RIPanel',
  perm_057020: 'Parameters,ReinsuranceParameters,RetentionLimit',
  perm_057025: 'Parameters,ReinsuranceParameters,TreatyLimit',
  perm_057030: 'Parameters,ReinsuranceParameters,TreatyParameters',
  perm_057035: 'Parameters,ReinsuranceParameters,VoluntaryCessionLimit',
  perm_057500: 'Parameters,ClaimsParameters',
  perm_057501: 'Parameters,ClaimsParameters,Screen',
  perm_057505: 'Parameters,ClaimsParameters,ClaimsEventType',
  perm_057510: 'Parameters,ClaimsParameters,ClaimsLimitperUser',
  perm_057515: 'Parameters,ClaimsParameters,ClaimsNatureofLoss',
  perm_057520: 'Parameters,ClaimsParameters,ClaimsPaymentType',
  perm_057525: 'Parameters,ClaimsParameters,ClaimsReserveCategory',
  perm_057530: 'Parameters,ClaimsParameters,ClaimsStatus',
  perm_058000: 'Parameters,AccountsParameters',
  perm_058001: 'Parameters,AccountsParameters,Screen',
  perm_058005: 'Parameters,AccountsParameters,AccountNo.Suffix',
  perm_058010: 'Parameters,AccountsParameters,BankAccount',
  perm_058015: 'Parameters,AccountsParameters,AccountingPeriod',
  perm_058020: 'Parameters,AccountsParameters,Fund',
  perm_058025: 'Parameters,AccountsParameters,GLAccount',
  perm_058030: 'Parameters,AccountsParameters,GLAnalysisCode',
  perm_058031: 'Parameters,AccountsParameters,GLDepartment',
  perm_058035: 'Parameters,AccountsParameters,GSTKey',
  perm_058045: 'Parameters,AccountsParameters,GSTStatus',
  perm_058040: 'Parameters,AccountsParameters,GSTMapping&Interface',
  perm_058050: 'Parameters,AccountsParameters,TransactionDateRange',
  perm_058500: 'Parameters,TreatyParameters',
  perm_058501: 'Parameters,TreatyParameters,Screen',
  perm_058505: 'Parameters,TreatyParameters,BusinessAnalysisGLCode',
  perm_058510: 'Parameters,TreatyParameters,BusinessAnalysisCode',
  perm_058515: 'Parameters,TreatyParameters,CalculationRate',
  perm_058520: 'Parameters,TreatyParameters,LineCalculation',
  perm_058525: 'Parameters,TreatyParameters,LineCalculationbyStatementType',
  perm_058530: 'Parameters,TreatyParameters,MainBusinessClass',
  perm_058535: 'Parameters,TreatyParameters,RetentionType',
  perm_058540: 'Parameters,TreatyParameters,RiskAreaGLCode',
  perm_058545: 'Parameters,TreatyParameters,RiskArea',
  perm_058550: 'Parameters,TreatyParameters,StatementType',
  perm_058555: 'Parameters,TreatyParameters,StatementLineGLCode',
  perm_058560: 'Parameters,TreatyParameters,StatementLineType',
  perm_058565: 'Parameters,TreatyParameters,StatementLineTypebyStatementType',
  perm_058570: 'Parameters,TreatyParameters,GLInterface2',
  perm_058575: 'Parameters,TreatyParameters,TreatyDetails',
  perm_058580: 'Parameters,TreatyParameters,TreatyReinsurance',
  perm_059000: 'Parameters,NewParameters',
  perm_059001: 'Parameters,NewParameters,Screen',
  perm_060000: 'TreatyAccounting',
  perm_060001: 'TreatyAccounting,Module',
  perm_061000: 'TreatyAccounting,ManageTreaties',
  perm_061001: 'TreatyAccounting,ManageTreaties,Screen',
  perm_062000: 'TreatyAccounting,SpecialFunctions',
  perm_062001: 'TreatyAccounting,SpecialFunctions,Screen',
  perm_062005: 'TreatyAccounting,SpecialFunctions,UploadTreatyPremium&Commission',
  perm_062010: 'TreatyAccounting,SpecialFunctions,UploadTreatyClaimsPayment&Reserve',
  perm_063000: 'TreatyAccounting,Documents',
  perm_063001: 'TreatyAccounting,Documents,Screen',
  perm_070000: 'InvestmentManagement',
  perm_070001: 'InvestmentManagement,Module',
  perm_090000: 'UserManagement',
  perm_090001: 'UserManagement,Module',
  perm_091000: 'UserManagement,Users',
  perm_091001: 'UserManagement,Users,Screen',
  perm_091500: 'UserManagement,Sessions',
  perm_091501: 'UserManagement,Sessions,Screen',
  perm_092000: 'UserManagement,Roles&Permissions',
  perm_092001: 'UserManagement,Roles&Permissions,Screen',
  perm_092500: 'UserManagement,UserSecurity',
  perm_092501: 'UserManagement,UserSecurity,Screen',
  perm_094000: 'CacheControl',
  perm_094001: 'CacheControl,Module',
  perm_094100: 'PublicAPITransaction',
  perm_094101: 'PublicAPITransaction,Module',
  perm_094500: 'ReportJobHistory',
  perm_094501: 'ReportJobHistory,Module',
  perm_091005: 'UserManagement,Users,NewUser',
  perm_091010: 'UserManagement,Users,EditUser',
  perm_091015: 'UserManagement,Users,QueryUser',
  perm_091020: 'UserManagement,Users,ExportUser',
  perm_092005: 'UserManagement,Roles&Permissions,NewRole&Permission',
  perm_092010: 'UserManagement,Roles&Permissions,EditRole&Permission',
  perm_092015: 'UserManagement,Roles&Permissions,DeleteRole&Permission',
  perm_092020: 'UserManagement,Roles&Permissions,CopyRole&Permission',
  perm_044000: 'Accounting,GeneralLedger',
  perm_044001: 'Accounting,GeneralLedger,Screen',
  perm_044005: 'Accounting,GeneralLedger,AmendGLTransaction',
  perm_044010: 'Accounting,GeneralLedger,BatchGLUpdate',
  perm_044015: 'Accounting,GeneralLedger,CloseFinancialYear',
  perm_044020: 'Accounting,GeneralLedger,ForeignExchangeEvaluation',
  perm_044025: 'Accounting,GeneralLedger,Journal',
  perm_044030: 'Accounting,GeneralLedger,ReinstateCloseFinancialYear',
  perm_044035: 'Accounting,GeneralLedger,StartNewFinancialYear',
  perm_044040: 'Accounting,GeneralLedger,EnterJournal',
  perm_044045: 'Accounting,GeneralLedger,EnterJournal,Section',
  perm_044050: 'Accounting,GeneralLedger,EnterJournal,SendForApproval',
  perm_044055: 'Accounting,GeneralLedger,EnterJournal,Reject',
  perm_044060: 'Accounting,GeneralLedger,EnterJournal,Approved&Post',
  perm_093500: 'BatchJobHistory',
  perm_093501: 'BatchJobHistory,Module',
  perm_093000: 'AuditLog',
  perm_093001: 'AuditLog,Module',
  perm_095000: 'UnlockRecord',
  perm_095001: 'UnlockRecord,Module',
  perm_095500: 'Dashboard',
  perm_095501: 'Dashboard,Module',
  perm_096000: 'Dashboard,Widgets',
  perm_096001: 'Dashboard,Widgets,Screen',
  perm_096005: 'Dashboard,Widgets,ToDoList',
  perm_096010: 'Dashboard,Widgets,Debug',
  perm_096015: 'Dashboard,Widgets,UsersOnline',
  perm_096020: 'Dashboard,Widgets,QuickLaunch',
  perm_096025: 'Dashboard,Widgets,MyClaimsNotifications',
  perm_042000: 'Accounting,Matching',
  perm_042001: 'Accounting,Matching,Screen',
  perm_042005: 'Accounting,Matching,BatchMatchTransactions',
  perm_042010: 'Accounting,Matching,MatchTransactions',
  perm_042015: 'Accounting,Matching,UndoMatchedTransactions',
  perm_042020: 'Accounting,Matching,MatchTransactionsUpload',
  perm_043000: 'Accounting,SpecialFunctions',
  perm_043001: 'Accounting,SpecialFunctions,Screen',
  perm_043005: 'Accounting,SpecialFunctions,GSTRe-billing',
  perm_043010: 'Accounting,SpecialFunctions,PostExchangeDifferences',
  perm_043015: 'Accounting,SpecialFunctions,ProcessCommVouchers',
  perm_043020: 'Accounting,SpecialFunctions,VoidAccountsTransaction',
  perm_043025: 'Accounting,SpecialFunctions,Write-OffSmallBalances',
  perm_043030: 'Accounting,SpecialFunctions,IFRSDataExtraction',
  perm_043035: 'Accounting,SpecialFunctions,DownloadGLTransactions',
  perm_043040: 'Accounting,SpecialFunctions,ExcludeGSTPatching',
  perm_045000: 'Accounting,Documents',
  perm_045001: 'Accounting,Documents,Screen',
  perm_045005: 'Accounting,Documents,AccountsDocumentation',
  perm_045010: 'Accounting,Documents,CommissionVoucher',
  perm_045015: 'Accounting,Documents,StatementofAccount'
}
